import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

/* eslint-disable no-param-reassign */
import { type CncUiState } from '../../structureDefinitions/uiState';
import { type CncNavigatePayload, cncNavigateTo, cncSetTo } from './uiActions';

const initialState: CncUiState = {
    stepTrail: [],
    reloadOnClose: false,
};

const slice = createSlice({
    name: 'cnc',
    initialState,
    reducers: {
        goBack: (state: CncUiState) => {
            if (state.stepTrail.length > 1) {
                state.stepTrail.pop();
            }
        },
        clearNavigationParams: (state: CncUiState) => {
            const currentStep = state.stepTrail[state.stepTrail.length - 1];
            if (currentStep && 'param' in currentStep) {
                currentStep.param = undefined;
            }
        },
        forceReloadOnClose: (state: CncUiState, action: PayloadAction<boolean>) => {
            state.reloadOnClose = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(
            cncSetTo,
            (state: CncUiState, action: PayloadAction<CncNavigatePayload>) => {
                state.stepTrail = [action.payload];
            },
        );
        builder.addCase(
            cncNavigateTo,
            (state: CncUiState, action: PayloadAction<CncNavigatePayload>) => {
                // if the action.payload component exists in trail - pop the stack until you find it
                const existingStepInTrail = state.stepTrail.findIndex(
                    (step) => step.step === action.payload.step,
                );
                if (existingStepInTrail !== -1) {
                    state.stepTrail = [
                        ...state.stepTrail.slice(0, existingStepInTrail),
                        action.payload,
                    ];
                } else {
                    state.stepTrail.push(action.payload);
                }
            },
        );
    },
});

const actions = { navigateTo: cncNavigateTo, setTo: cncSetTo, ...slice.actions };
export const cncUiActions = actions;

export default slice.reducer;
